<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">アイコン掲載順設定</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="element-column">
          <div class="column-list">
            <label class="list-input-title">グループ</label>
            <div class="list-input-content">
              <select id="cmb_MarkGroup" #cmb_MarkGroup [style.width.px]="'180'" [tabindex]="0"
                [(ngModel)]="kymw1509Model.selectedMarkGroup" (change)="eventMarkGroupName_CHANGEHandler()">
                <ng-template ngFor let-item [ngForOf]="kymw1509Model.markGroupList">
                  <option value="{{item.MarkGroupCode}}">{{item.Caption}}</option>
                </ng-template>
              </select>
            </div>
          </div>

          <wj-flex-grid #dtg_IconList id="dtg_IconList" [itemsSource]="kymw1509Model.displayIconList"
            [headersVisibility]="'All'" [selectionMode]="'Row'" [allowSorting]="false" [allowDragging]="'Rows'" 
            (draggingRow)="onDraggingRow(dtg_IconList, $event)" (draggedRow)="onDraggedRow(dtg_IconList, $event)"
            horizontalScrollPolicy="on" verticalScrollPolicy="on" [autoScroll]="true">
            <wj-flex-grid-column [minWidth]="5" [header]="'アイコン\nコード'" [width]="80" [binding]="'iconCode'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'アイコン名'" [width]="320" [binding]="'iconName'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'アイコン画像'" [width]="325" [binding]="'iconFileUrl'" [align]="'center'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <div [style.text-align]="'center'">
                  <img src="{{cell.item.iconFileUrl}}" class="cell-image">
                </div>
              </ng-template>
            </wj-flex-grid-column>
          </wj-flex-grid>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_setting" class="btn-primary" (click)="eventSetting_CLICKHandler()"
            forcedEnabledMode="none" [tabindex]="0">設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickWindowClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>
